module.exports = __webpack_public_path__ + "static/media/certIcon.d09489c3.png";